<!--
 * @Author: Lemon C
 * @Date: 2024-05-30 10:36:22
 * @LastEditTime: 2024-05-30 11:36:11
-->
<template>
    <div class="sup-highlight-text">
        <div class="text-box" v-html="highlightedText"></div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
    originalText: String,
    highlightWords: Array,
    highColor: String,
});

watch([() => props.highlightWords, () => props.originalText], () => {
    highlightedText.value = highlightText(props.originalText, props.highlightWords);
});

const highlightedText = ref('');

onMounted(() => {
    highlightedText.value = highlightText(props.originalText, props.highlightWords);
});

const highlightText = (text, keywords) => {
    // 首先按关键词长度降序排序
    const sortedKeywords = keywords.sort((a, b) => b.length - a.length);
    let highlighted = text;
    sortedKeywords.forEach((keyword) => {
        // 使用正则表达式替换，确保不会替换已经被高亮的部分
        // 注意这里使用了(?<!...)和(?!...)来避免替换已经被高亮的部分
        const regex = new RegExp(`(?<!</span>)${escapeRegExp(keyword)}(?!</span>)`, 'g');
        highlighted = highlighted.replace(regex, `<span style="color:${props.highColor};font-weight: bold;">${keyword}</span>`);
    });
    return highlighted;
};

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& 表示与整个匹配项相同的文本
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-highlight-text {
    position: relative;
}
</style>
